module.exports = __webpack_public_path__ + "static/media/ReliableRolemodel.697f0295.svg";